import { colors, fontSizes } from "@hubrise/react-components"
import styled from "styled-components"

import StatefulField from "shared/components/StatefulField"

export const SkuName = styled.div`
  font-size: ${fontSizes._14};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 8rem;
  display: inline-block;
`

export const FieldServings = styled(StatefulField.NumberIput)`
  input {
    width: 4rem;
  }
`

export const FieldBarcodes = styled(StatefulField.Select)`
  min-width: 10rem;
`

export const Hint = styled.div`
  display: flex;
  justify-content: end;
  font-size: ${fontSizes._12};
  color: ${colors.textLight};
  font-style: italic;
  margin-top: 0.5rem;
  margin-right: 1rem;
`
